import * as Types from 'src/actions/juridical-person/update/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import ValidatorService from 'src/services/validation/Validation.service';
import { Validation } from 'src/services/validation/Validator';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import { getJuridicalPerson } from 'src/actions/juridical-person/get/GetJuridicalPerson.actions';

export interface UpdateJuridicalPersonAttempt extends Action {
  type: Types.UPDATE_JURIDICAL_PERSON_ATTEMPT;
}

export interface UpdateJuridicalPersonSuccess extends Action {
  type: Types.UPDATE_JURIDICAL_PERSON_SUCCESS;
}

export interface UpdateJuridicalPersonFailure extends Action {
  type: Types.UPDATE_JURIDICAL_PERSON_FAILURE;
  payload: {};
}

export type UpdateJuridicalPersonAction =
  UpdateJuridicalPersonAttempt |
  UpdateJuridicalPersonSuccess |
  UpdateJuridicalPersonFailure;

export interface UpdateJuridicalPersonThunk extends ThunkAction<Promise<UpdateJuridicalPersonAction>, RootState, null> {
}

export const updateJuridicalPersonAttempt: ActionCreator<UpdateJuridicalPersonAttempt> = () => (
  {type: Types.UPDATE_JURIDICAL_PERSON_ATTEMPT}
);

export const updateJuridicalPersonSuccess: ActionCreator<UpdateJuridicalPersonSuccess> = () => (
  {
    type: Types.UPDATE_JURIDICAL_PERSON_SUCCESS,
  }
);

export const updateJuridicalPersonFailure: ActionCreator<UpdateJuridicalPersonFailure> = (error: {}) => (
  {
    type: Types.UPDATE_JURIDICAL_PERSON_FAILURE,
    payload: error
  }
);

export const updateJuridicalPerson: ActionCreator<UpdateJuridicalPersonThunk> = (
  person: JuridicalPerson
): UpdateJuridicalPersonThunk => {

  return (dispatch: Dispatch<RootState>): Promise<UpdateJuridicalPersonAction> => {

    dispatch(updateJuridicalPersonAttempt());

    const restrictions: Validation[] = [
      {value: person.name, message: 'name'},
      {value: person.surname, message: 'surname'},
      {value: person.enterpriseName, message: 'enterpriseName'},
    ];

    const validation = ValidatorService.validate(restrictions);

    return validation.then(() => {

      return ApiClient.juridicalPerson.update(person.id!, person)
        .then((response: AxiosResponse): UpdateJuridicalPersonSuccess => {

          // TODO: This is a really dirty hack in order to be able to release
          dispatch(getJuridicalPerson(person.id));
          // TODO: End of the really dirty hack, please remove

          return dispatch(updateJuridicalPersonSuccess());
        }).catch((e: { response: { data: { errors: {}, error: {} } } }): UpdateJuridicalPersonFailure => {
          const errors: {} | string = e && e.response && e.response.data &&
            ( e.response.data.errors || e.response.data.error );

          const errorMessages = ValidatorService
            .translateValidations(errors);

          return dispatch(updateJuridicalPersonFailure(errorMessages));
        });
    }).catch((errors) => {
      return dispatch(updateJuridicalPersonFailure(errors));
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/juridical-person/update/UpdateJuridicalPerson.actions.tsx